<div class="feedback-container">
    <div class="reservations-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/shield_check_red.png" alt="shield_check_red Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Réservations / <span *ngIf="feedbackData" class="username">{{feedbackData.reservationTitle}}</span> / <span class="username">Évaluation du Service</span></span>
            </span>
        </div>

        <div class="header-right">
            <button class="back-btn" (click)="goToList()">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="add-icon">
                <span>Retour</span>
            </button>
        </div>
    </div>
    <!-- Header -->
    <!--<div class="feedback-header">
        <div class="header-content">
            <p class="subtitle">{{ frenchTranslations.subtitle }}</p>
            <div class="update-info" *ngIf="feedbackData">
                <div class="update-badge" [ngClass]="feedbackData.status?.toLowerCase()">
                    <span>{{ feedbackData.status }}</span>
                    <span class="update-count">(Mise à jour {{ feedbackData.updateCount }}/{{ maxUpdates }})</span>
                </div>
                <p *ngIf="feedbackData.submittedAt" class="submission-date">
                    Dernière soumission : {{ feedbackData.submittedAt | date:'dd/MM/yyyy HH:mm' }}
                </p>
            </div>
        </div>
    </div>-->

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
        <div class="spinner"></div>
        <p>{{ frenchTranslations.loadingFeedback }}</p>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage && !isLoading" class="alert-card-error">
        <div class="alert-title">Erreur</div>
        <div class="alert-text">{{ errorMessage }}</div>
    </div>

    <!-- Feedback Form -->
    <div *ngIf="!isLoading && isLoaded && !errorMessage" class="feedback-form-container">
        <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()" class="feedback-form">

            <!-- Service Ratings Section -->
            <div class="section-card">
                <h2 class="section-title">Évaluation du Service</h2>
                <p class="subtitle">{{ frenchTranslations.subtitle }}</p>

                <div class="rating-group">
                    <div class="rating-item">
                        <label class="rating-label">{{ frenchTranslations.overallService }}</label>
                        <app-rating-stars formControlName="overallRating" [helpText]="getRatingLabel(overallRating)"></app-rating-stars>
                        <div class="form_error" *ngIf="hasError('overallRating', 'required')">
                            {{ getErrorMessage('overallRating', 'required') }}
                        </div>
                    </div>

                    <div class="rating-item">
                        <label class="rating-label">{{ frenchTranslations.serviceQuality }}</label>
                        <app-rating-stars formControlName="serviceQualityRating" [helpText]="getRatingLabel(serviceQualityRating)"></app-rating-stars>
                        <div class="form_error" *ngIf="hasError('serviceQualityRating', 'required')">
                            {{ getErrorMessage('serviceQualityRating', 'required') }}
                        </div>
                    </div>

                    <div class="rating-item">
                        <label class="rating-label">{{ frenchTranslations.punctuality }}</label>
                        <app-rating-stars formControlName="punctualityRating" [helpText]="getRatingLabel(punctualityRating)"></app-rating-stars>
                        <div class="form_error" *ngIf="hasError('punctualityRating', 'required')">
                            {{ getErrorMessage('punctualityRating', 'required') }}
                        </div>
                    </div>

                    <div class="rating-item">
                        <label class="rating-label">{{ frenchTranslations.communication }}</label>
                        <app-rating-stars formControlName="communicationRating" [helpText]="getRatingLabel(communicationRating)"></app-rating-stars>
                        <div class="form_error" *ngIf="hasError('communicationRating', 'required')">
                            {{ getErrorMessage('communicationRating', 'required') }}
                        </div>
                    </div>
                </div>

                <!-- Comment Section -->
                <div class="comment-section">
                    <label class="comment-label">Commentaire Global</label>
                    <textarea formControlName="comment" class="comment-textarea" rows="4" placeholder="{{ frenchTranslations.commentPlaceholder }}" [maxLength]="300"></textarea>
                    <div class="comment-footer">
                        <div class="form_error" *ngIf="hasError('comment', 'maxlength')">
                            {{ getErrorMessage('comment', 'maxlength') }}
                        </div>
                        <div class="char-counter">
                            {{ getCommentLength('comment') }}/300 {{ frenchTranslations.charactersRemaining }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Agent Feedbacks Section -->
            <div class="section-card" *ngIf="agentFeedbacks.length > 0">
                <h2 class="section-title">{{ frenchTranslations.agentFeedback }}</h2>

                <div class="agents-list">
                    <div *ngFor="let agent of agentFeedbacks.controls; let i = index" class="agent-feedback-card" [formGroup]="getAgentFormGroup(i)">

                        <div class="agent-header">
                            <div class="agent-image-col">
                                <img [src]="getAgentProfileImage(i)" [alt]="getAgentName(i)" class="agent-image" [class.full]="getAgentProfileImage(i)">
                            </div>
                            <h3 class="agent-title">
                                <span class="agent-name">{{ getAgentName(i) }}</span>
                            </h3>
                        </div>

                        <div class="agent-ratings">
                            <div class="rating-item">
                                <label class="rating-label">{{ frenchTranslations.professionalism }}</label>
                                <app-rating-stars formControlName="professionalismRating" [helpText]="getRatingLabel(getAgentRating(i, 'professionalismRating'))"></app-rating-stars>
                                <div class="form_error" *ngIf="hasAgentError(i, 'professionalismRating', 'required')">
                                    {{ getErrorMessage('professionalismRating', 'required') }}
                                </div>
                            </div>

                            <div class="rating-item">
                                <label class="rating-label">{{ frenchTranslations.attitude }}</label>
                                <app-rating-stars formControlName="attitudeRating" [helpText]="getRatingLabel(getAgentRating(i, 'attitudeRating'))"></app-rating-stars>
                                <div class="form_error" *ngIf="hasAgentError(i, 'attitudeRating', 'required')">
                                    {{ getErrorMessage('attitudeRating', 'required') }}
                                </div>
                            </div>

                            <div class="rating-item">
                                <label class="rating-label">{{ frenchTranslations.efficiency }}</label>
                                <app-rating-stars formControlName="efficiencyRating" [helpText]="getRatingLabel(getAgentRating(i, 'efficiencyRating'))"></app-rating-stars>
                                <div class="form_error" *ngIf="hasAgentError(i, 'efficiencyRating', 'required')">
                                    {{ getErrorMessage('efficiencyRating', 'required') }}
                                </div>
                            </div>
                        </div>

                        <!-- Agent Comment -->
                        <div class="agent-comment">
                            <label class="comment-label">Commentaire pour cet agent</label>
                            <textarea formControlName="comment" class="comment-textarea" rows="3" placeholder="{{ frenchTranslations.agentCommentPlaceholder }}" [maxLength]="300"></textarea>
                            <div class="comment-footer">
                                <div class="form_error" *ngIf="hasAgentError(i, 'comment', 'maxlength')">
                                    {{ getErrorMessage('comment', 'maxlength') }}
                                </div>
                                <div class="char-counter">
                                    {{ getAgentCommentLength(i) }}/300 {{ frenchTranslations.charactersRemaining }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="form-actions">
                <button type="submit" class="submit-btn" [disabled]="feedbackForm.invalid || isSubmitting || !canUpdate">
                    <span *ngIf="isSubmitting" class="spinner"></span>
                    {{ submitButtonText }}
                </button>

                <div class="form-help" *ngIf="feedbackData">
                    <p class="help-text">
                        Vous pouvez mettre à jour votre évaluation <strong>{{ remainingUpdates }}</strong> fois.
                    </p>
                </div>
            </div>
        </form>
    </div>
</div>